import { useUserMe } from "~/components/user/composables/useUser";
export default defineNuxtRouteMiddleware(async () => {
  const { teamMember, refetch } = useUserMe();

  await refetch();

  if (teamMember.value?.is_onboarded) return navigateTo("/logout");
});
